import React from 'react';
import "./ArchiveIcon.css"



const ArchiveIcon = ({ onClick, isArchived }) => (
  <>
    {isArchived ? (
      <svg
        className="unarchive-icon cr-pointer"
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        onClick={onClick}
      >
        <path
          d="M15.75 2.25H2.25C1.83579 2.25 1.5 2.58579 1.5 3V5.25C1.5 5.66421 1.83579 6 2.25 6H15.75C16.1642 6 16.5 5.66421 16.5 5.25V3C16.5 2.58579 16.1642 2.25 15.75 2.25Z"
          stroke="#094C80"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3 6V14.25C3 14.6478 3.15804 15.0294 3.43934 15.3107C3.72064 15.592 4.10218 15.75 4.5 15.75H13.5C13.8978 15.75 14.2794 15.592 14.5607 15.3107C14.842 15.0294 15 14.6478 15 14.25V6"
          stroke="#094C80"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M9 12.375L9 8.625" stroke="#094C80" stroke-width="1.5" />
        <path
          d="M6.75 10.5L9 8.25L11.25 10.5"
          stroke="#094C80"
          stroke-width="1.5"
        />
      </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        style={{ cursor: "pointer" }}
        onClick={onClick}
      >
        <path d="M9.5 8V11.75" stroke="#BD3D44" stroke-width="1.5" />
        <path
          d="M11.75 9.875L9.5 12.125L7.25 9.875"
          stroke="#BD3D44"
          stroke-width="1.5"
        />
        <path
          d="M3.5 5.75V14C3.5 14.3978 3.65804 14.7794 3.93934 15.0607C4.22064 15.342 4.60218 15.5 5 15.5H14C14.3978 15.5 14.7794 15.342 15.0607 15.0607C15.342 14.7794 15.5 14.3978 15.5 14V5.75"
          stroke="#BD3D44"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16.25 2H2.75C2.33579 2 2 2.33579 2 2.75V5C2 5.41421 2.33579 5.75 2.75 5.75H16.25C16.6642 5.75 17 5.41421 17 5V2.75C17 2.33579 16.6642 2 16.25 2Z"
          stroke="#BD3D44"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    )}
  </>
);

export default ArchiveIcon;
